import { useActualLoggedInUserInfo } from "../../services/getLoggedInUserInfo.ts";
import { ActualAdminPanel } from "./ActualAdminPanel.tsx";

export const AdminPanel = () => {
  const { userInfo } = useActualLoggedInUserInfo();

  if (userInfo?.isVIPAdminUser === true) return <ActualAdminPanel />;

  return <></>;
};
